import ClearIcon from "@mui/icons-material/Clear";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { debounce } from "lodash";
import { useState } from "react";
import { UseFormRegister, type UseFormWatch } from "react-hook-form";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import type { B2B_Invoice_list, IB2B_Invoice } from "../type/b2bType";
// Define the Country type

const InvoiceB2BSelectFieldList = ({
	register,
	fieldName,
	label,
	hideCustomLabel,
	isRequired,
	mt,
	onChange,
	defaultValue,
	watch,
}: {
	register?: UseFormRegister<any>;
	fieldName: string;
	label?: string;
	hideCustomLabel?: boolean;
	isRequired?: boolean;
	mt?: "0";
	onChange?: (e: number) => void;
	defaultValue?: {
		country_id: number;
		country_name: string;
	};
	watch?: UseFormWatch<any>;
}) => {
	const b2b_id = watch("b2b_id");
	const [search, setSearch] = useState("");
	const { data, isLoading } = useGetQueryWithTotal<B2B_Invoice_list[]>({
		endPoint: "/api/admin/b2b/invoice",
		queryKeys: ["b2b-money-receipt", search],
		params: {
			invoice_no: search,
			status: "unpaid",
			b2b_id,
		},
	});
	// Fetch country data from the API

	return (
		<Box sx={{ mt: mt ? 0 : 2 }}>
			{!hideCustomLabel && (
				<label>
					{label}{" "}
					{isRequired && <span style={{ color: "red" }}>*</span>}
				</label>
			)}

			<Autocomplete
				// defaultValue={defaultValue || null}
				disabled={!b2b_id}
				options={data?.data || []}
				getOptionLabel={(option: B2B_Invoice_list) =>
					`${option?.invoice_no}-(${option.due})`
				}
				onInputChange={debounce((_, value) => {
					setSearch(value);
				}, 300)}
				onChange={(_, value: B2B_Invoice_list) => {
					register &&
						register(fieldName).onChange({
							target: {
								name: fieldName,
								value: value ? value.id : "",
							},
						});
					if (value?.id) {
						onChange && onChange(value?.id);
					}
				}}
				isOptionEqualToValue={(option, value) =>
					option?.id === value?.id
				}
				loading={isLoading}
				clearIcon={
					<span
						onClick={() => {
							setSearch("");
						}}
					>
						<ClearIcon fontSize='small' />
					</span>
				}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder='Enter Invoice'
						required={isRequired}
						label={hideCustomLabel ? label : ""}
						variant='outlined'
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress
											color='inherit'
											size={20}
										/>
									) : null}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
			/>
		</Box>
	);
};

export default InvoiceB2BSelectFieldList;
